import { IdPType } from './sso';
import { Thread } from './thread';

export enum Role {
  USER = 'user',
  ORG_USER_ADMIN = 'org-user-admin',
  ORG_DATA_ADMIN = 'org-data-admin',
  SUPER_ORG_ADMIN = 'super-org-admin',
  SUPER_USER_ADMIN = 'super-user-admin',
  SUPER_DATA_ADMIN = 'super-data-admin',
}

export interface Credentials {
  email: string;
  password: string;
}

export interface User {
  id: string;
  email: string;
  name: string;
  roles: Array<Role>;
  organizations: Organization[];
}

export interface OrganizationMetadata {
  name: string;
  slug: string;
  logo?: string;
  created_at?: string;
  suggestions: string[];
  auth_method?: 'password' | 'sso';
  subdomain?: string;
  zitadel_org_id?: string;
  idp_type?: IdPType;
  logo_url?: string;
}

export interface Organization extends OrganizationMetadata {
  id: string;
  seat_limit?: number;
  seats_used?: number;
}

export interface Session extends User {
  fileCount: number;
  threads: Array<Thread>;
}
